<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_news_notification')
}

const isOnNotificationsSection = computed(() => {
  return route.path.startsWith('/news/notifications')
})

const goToNotifications = () => {
  router.push('/news/notifications')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/news.webm"
  >
    <template #text>
      <p class="pb-2">
        I understand you are busy, and can't check the news page all the time.
      </p>
      <p class="pb-2">
        For important events, we could notify you directly.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Click on the bell icon <GenericIcon type="bell"/> in the News section to access notification settings. Then click on "Add new device" to setup notifications for your current device.
      </Alert>
      <Alert type="info" class="md:hidden">
        In the News section, tap the bell icon <GenericIcon type="bell"/> to configure your notifications. Then tap on "Add new device" to access notifications for your current device.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnNotificationsSection" @click="goToNotifications" class="mr-2">
        Go to Notifications
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Continue
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>